import { isDevelopment } from '@/shared/constants/env.ts'

/** 앱 기본 HOST **/
export const APP_HOST = isDevelopment ? 'https://dev-app.lair.fi' : 'https://app.lair.fi'

export const IS_INJECTIVE_TEST_SERVER = false
